<template>
  <div class="page-default">
		<div id="liveboxes" class="clearfix">
			<div class="livebox float-left" v-for="stream in streams" :key="stream.videoId">
				<p>{{ stream.district }}</p>
				<video :id="stream.videoId" autoplay muted controls></video>
				<div :id="stream.mapId" class="mapcont"></div>
				<div class="pin"></div>
			</div>								
			<div class="livebox float-left">				
			</div>
			<div class="livebox float-left"></div>
		</div>
	</div>
</template>

<script>
import flvjs from "flv.js";
import qs from "querystring";
import API from "@/api";
import "mapbox-gl";
import "@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css";

export default {
  name: "live",

  data() {
    return {
			streams: [
				{
					videoId: "video-gombak",
					mapId: "map-gombak",
					district: "Gombak / Hulu Selangor",
					imei: "862798050167143",
					lat: 3.1390, 
					lng: 101.6869,
					map: null,
					mapMarker: null,
					flvPlayer: null
				},
				{
					videoId: "video-ks",
					mapId: "map-ks",
					district: "Kuala Selangor",
					imei: "862798050163480",
					lat: 3.1390, 
					lng: 101.6869,
					map: null,
					mapMarker: null,
					flvPlayer: null
				}
			]
		};
  },
  
  methods: {
		fetchCoordinates() {
			return new Promise(async (resolve) => {
				const res = await API.get("livestreams/locations");				
				
				Object.keys(res.data).forEach((key) => {
					const index = this.streams.findIndex((stream) => stream.imei === `${key}`);
					this.streams[index].lat = res.data[key].lat;
					this.streams[index].lng = res.data[key].lng;
				});
				
				this.streams.forEach((stream) => {
					if (stream.map === null)
						return;
						
					stream.map.setCenter([stream.lng, stream.lat]);
				});
				
				resolve();
			})
		}, 
		
		async fetchVideos() {
			for (const stream of this.streams) {
				try {
					const res = await API.get(`livestreams/${stream.imei}`);	
					
					stream.map = new mapboxgl.Map({
						container: stream.mapId,
						style: "mapbox://styles/mapbox/dark-v11",
						center: [stream.lng, stream.lat],
						zoom: 12,
					});						
					
					const videoElement = document.getElementById(stream.videoId);			
					const url = res.data["ws-flv"].replace("ws://", "wss://").replace("149.129.82.206:8880", "hongkong.jimirtmp.com:8890") + res.data.token;			
		
					if (stream.flvPlayer) {					
						stream.flvPlayer.unload();					
						stream.flvPlayer.detachMediaElement();
					}

					stream.flvPlayer = flvjs.createPlayer({
						type: "flv",
						isLive: true,
						url
					}, {
						autoCleanupSourceBuffer: true,
						enableStashBuffer: false,
						deferLoadAfterSourceOpen: true,
						fixAudioTimestampGap: true
					});
					
					stream.flvPlayer.attachMediaElement(videoElement);
					
					stream.flvPlayer.load();
					
					stream.flvPlayer.play().then(() => {
						stream.flvPlayer.muted = true;
					});	
				}
				catch (err) {
					
				}				
			}
		}
  },
  
  async mounted() {
		mapboxgl.accessToken = process.env.VUE_APP_MAPBOX_KEY;
		
		await this.fetchVideos();
		
		setInterval(async () => {
			await this.fetchVideos();
		}, 30000);
				
		await this.fetchCoordinates();
		
		setInterval(async () => {			
			await this.fetchCoordinates();
		}, 15000);
  }
};
</script>
